import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Users, Search, Plus, Edit2, Trash2, X, Filter, ChevronLeft, ChevronRight } from 'lucide-react';
import AuroraFloatingCard from '../ui/AuroraFloatingCard';
// Öğrenci veri tipi tanımı
interface Student {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  parentName: string;
  parentPhone: string;
  class: string;
  registrationDate: string;
}
// Sınıf seçenekleri
const classOptions = ['5-A', '5-B', '6-A', '6-B', '7-A', '7-B', '8-A', '8-B', '9-A', '9-B', '10-A', '10-B', '11-A', '11-B', '12-A', '12-B'];
// Örnek öğrenci verileri
const initialStudents: Student[] = [{
  id: 1,
  firstName: 'Ahmet',
  lastName: 'Yılmaz',
  email: 'ahmet.yilmaz@example.com',
  phone: '555-123-4567',
  parentName: 'Mehmet Yılmaz',
  parentPhone: '555-987-6543',
  class: '8-A',
  registrationDate: '15.09.2023'
}, {
  id: 2,
  firstName: 'Ayşe',
  lastName: 'Demir',
  email: 'ayse.demir@example.com',
  phone: '555-234-5678',
  parentName: 'Fatma Demir',
  parentPhone: '555-876-5432',
  class: '7-B',
  registrationDate: '12.09.2023'
}, {
  id: 3,
  firstName: 'Mehmet',
  lastName: 'Kaya',
  email: 'mehmet.kaya@example.com',
  phone: '555-345-6789',
  parentName: 'Ali Kaya',
  parentPhone: '555-765-4321',
  class: '9-A',
  registrationDate: '10.09.2023'
}, {
  id: 4,
  firstName: 'Zeynep',
  lastName: 'Şahin',
  email: 'zeynep.sahin@example.com',
  phone: '555-456-7890',
  parentName: 'Ayşe Şahin',
  parentPhone: '555-654-3210',
  class: '6-B',
  registrationDate: '18.09.2023'
}, {
  id: 5,
  firstName: 'Mustafa',
  lastName: 'Öztürk',
  email: 'mustafa.ozturk@example.com',
  phone: '555-567-8901',
  parentName: 'Hasan Öztürk',
  parentPhone: '555-543-2109',
  class: '8-B',
  registrationDate: '14.09.2023'
}, {
  id: 6,
  firstName: 'Elif',
  lastName: 'Yıldız',
  email: 'elif.yildiz@example.com',
  phone: '555-678-9012',
  parentName: 'Zehra Yıldız',
  parentPhone: '555-432-1098',
  class: '10-A',
  registrationDate: '11.09.2023'
}, {
  id: 7,
  firstName: 'Emre',
  lastName: 'Aydın',
  email: 'emre.aydin@example.com',
  phone: '555-789-0123',
  parentName: 'Murat Aydın',
  parentPhone: '555-321-0987',
  class: '11-B',
  registrationDate: '13.09.2023'
}, {
  id: 8,
  firstName: 'Selin',
  lastName: 'Çelik',
  email: 'selin.celik@example.com',
  phone: '555-890-1234',
  parentName: 'Canan Çelik',
  parentPhone: '555-210-9876',
  class: '12-A',
  registrationDate: '16.09.2023'
}, {
  id: 9,
  firstName: 'Burak',
  lastName: 'Koç',
  email: 'burak.koc@example.com',
  phone: '555-901-2345',
  parentName: 'Serkan Koç',
  parentPhone: '555-109-8765',
  class: '7-A',
  registrationDate: '17.09.2023'
}, {
  id: 10,
  firstName: 'Deniz',
  lastName: 'Aksoy',
  email: 'deniz.aksoy@example.com',
  phone: '555-012-3456',
  parentName: 'Kemal Aksoy',
  parentPhone: '555-098-7654',
  class: '9-B',
  registrationDate: '19.09.2023'
},
// Yeni eklenen öğrenciler - 5-A Sınıfı
{
  id: 11,
  firstName: 'Aylin',
  lastName: 'Yücel',
  email: 'aylin.yucel@example.com',
  phone: '555-111-2222',
  parentName: 'Selim Yücel',
  parentPhone: '555-222-3333',
  class: '5-A',
  registrationDate: '05.09.2023'
}, {
  id: 12,
  firstName: 'Cem',
  lastName: 'Türk',
  email: 'cem.turk@example.com',
  phone: '555-333-4444',
  parentName: 'Hakan Türk',
  parentPhone: '555-444-5555',
  class: '5-A',
  registrationDate: '06.09.2023'
}, {
  id: 13,
  firstName: 'Defne',
  lastName: 'Acar',
  email: 'defne.acar@example.com',
  phone: '555-555-6666',
  parentName: 'Melis Acar',
  parentPhone: '555-666-7777',
  class: '5-A',
  registrationDate: '04.09.2023'
},
// 5-B Sınıfı
{
  id: 14,
  firstName: 'Ege',
  lastName: 'Kılıç',
  email: 'ege.kilic@example.com',
  phone: '555-777-8888',
  parentName: 'Ozan Kılıç',
  parentPhone: '555-888-9999',
  class: '5-B',
  registrationDate: '07.09.2023'
}, {
  id: 15,
  firstName: 'Funda',
  lastName: 'Eren',
  email: 'funda.eren@example.com',
  phone: '555-999-0000',
  parentName: 'Leyla Eren',
  parentPhone: '555-000-1111',
  class: '5-B',
  registrationDate: '08.09.2023'
},
// 6-A Sınıfı
{
  id: 16,
  firstName: 'Gökhan',
  lastName: 'Bilgin',
  email: 'gokhan.bilgin@example.com',
  phone: '555-111-3333',
  parentName: 'Tarık Bilgin',
  parentPhone: '555-222-4444',
  class: '6-A',
  registrationDate: '05.09.2023'
}, {
  id: 17,
  firstName: 'Hande',
  lastName: 'Yavuz',
  email: 'hande.yavuz@example.com',
  phone: '555-333-5555',
  parentName: 'Selma Yavuz',
  parentPhone: '555-444-6666',
  class: '6-A',
  registrationDate: '06.09.2023'
},
// 7-A Sınıfı (Ek öğrenciler)
{
  id: 18,
  firstName: 'İrem',
  lastName: 'Doğan',
  email: 'irem.dogan@example.com',
  phone: '555-555-7777',
  parentName: 'Mert Doğan',
  parentPhone: '555-666-8888',
  class: '7-A',
  registrationDate: '03.09.2023'
}, {
  id: 19,
  firstName: 'Kaan',
  lastName: 'Arslan',
  email: 'kaan.arslan@example.com',
  phone: '555-777-9999',
  parentName: 'Arzu Arslan',
  parentPhone: '555-888-0000',
  class: '7-A',
  registrationDate: '04.09.2023'
},
// 8-A Sınıfı (Ek öğrenciler)
{
  id: 20,
  firstName: 'Levent',
  lastName: 'Güneş',
  email: 'levent.gunes@example.com',
  phone: '555-999-1111',
  parentName: 'Tülay Güneş',
  parentPhone: '555-000-2222',
  class: '8-A',
  registrationDate: '01.09.2023'
}, {
  id: 21,
  firstName: 'Mine',
  lastName: 'Korkmaz',
  email: 'mine.korkmaz@example.com',
  phone: '555-111-4444',
  parentName: 'Faik Korkmaz',
  parentPhone: '555-222-5555',
  class: '8-A',
  registrationDate: '02.09.2023'
},
// 9-A Sınıfı (Ek öğrenciler)
{
  id: 22,
  firstName: 'Nazlı',
  lastName: 'Tekin',
  email: 'nazli.tekin@example.com',
  phone: '555-333-6666',
  parentName: 'Suat Tekin',
  parentPhone: '555-444-7777',
  class: '9-A',
  registrationDate: '05.09.2023'
}, {
  id: 23,
  firstName: 'Oğuz',
  lastName: 'Yalçın',
  email: 'oguz.yalcin@example.com',
  phone: '555-555-8888',
  parentName: 'Filiz Yalçın',
  parentPhone: '555-666-9999',
  class: '9-A',
  registrationDate: '06.09.2023'
},
// 10-A Sınıfı (Ek öğrenciler)
{
  id: 24,
  firstName: 'Pelin',
  lastName: 'Şener',
  email: 'pelin.sener@example.com',
  phone: '555-777-0000',
  parentName: 'Murat Şener',
  parentPhone: '555-888-1111',
  class: '10-A',
  registrationDate: '07.09.2023'
}, {
  id: 25,
  firstName: 'Rıza',
  lastName: 'Tunç',
  email: 'riza.tunc@example.com',
  phone: '555-999-2222',
  parentName: 'Sevim Tunç',
  parentPhone: '555-000-3333',
  class: '10-A',
  registrationDate: '08.09.2023'
},
// 11-A Sınıfı
{
  id: 26,
  firstName: 'Seda',
  lastName: 'Güzel',
  email: 'seda.guzel@example.com',
  phone: '555-111-5555',
  parentName: 'Cengiz Güzel',
  parentPhone: '555-222-6666',
  class: '11-A',
  registrationDate: '01.09.2023'
}, {
  id: 27,
  firstName: 'Tarık',
  lastName: 'Özkan',
  email: 'tarik.ozkan@example.com',
  phone: '555-333-7777',
  parentName: 'Nalan Özkan',
  parentPhone: '555-444-8888',
  class: '11-A',
  registrationDate: '02.09.2023'
},
// 12-A Sınıfı (Ek öğrenciler)
{
  id: 28,
  firstName: 'Ufuk',
  lastName: 'Erdem',
  email: 'ufuk.erdem@example.com',
  phone: '555-555-9999',
  parentName: 'Berna Erdem',
  parentPhone: '555-666-0000',
  class: '12-A',
  registrationDate: '03.09.2023'
}, {
  id: 29,
  firstName: 'Vildan',
  lastName: 'Kara',
  email: 'vildan.kara@example.com',
  phone: '555-777-1111',
  parentName: 'Selçuk Kara',
  parentPhone: '555-888-2222',
  class: '12-A',
  registrationDate: '04.09.2023'
},
// 12-B Sınıfı
{
  id: 30,
  firstName: 'Yusuf',
  lastName: 'Aslan',
  email: 'yusuf.aslan@example.com',
  phone: '555-999-3333',
  parentName: 'Hülya Aslan',
  parentPhone: '555-000-4444',
  class: '12-B',
  registrationDate: '05.09.2023'
}, {
  id: 31,
  firstName: 'Zeliha',
  lastName: 'Kurt',
  email: 'zeliha.kurt@example.com',
  phone: '555-111-6666',
  parentName: 'Kerem Kurt',
  parentPhone: '555-222-7777',
  class: '12-B',
  registrationDate: '06.09.2023'
}];
export function OgrenciYonetimi() {
  // State tanımlamaları
  const [students, setStudents] = useState<Student[]>(initialStudents);
  const [filteredStudents, setFilteredStudents] = useState<Student[]>(students);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedClass, setSelectedClass] = useState<string>('');
  const [showAddModal, setShowAddModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [currentStudent, setCurrentStudent] = useState<Student | null>(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const studentsPerPage = 5;
  // Form state'i
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    parentName: '',
    parentPhone: '',
    class: classOptions[0]
  });
  // Form validasyon hataları
  const [formErrors, setFormErrors] = useState({
    firstName: ''
  });
  // Öğrenci arama ve filtreleme
  useEffect(() => {
    let result = students;
    // İsme göre arama
    if (searchTerm) {
      result = result.filter(student => `${student.firstName} ${student.lastName}`.toLowerCase().includes(searchTerm.toLowerCase()));
    }
    // Sınıfa göre filtreleme
    if (selectedClass) {
      result = result.filter(student => student.class === selectedClass);
    }
    setFilteredStudents(result);
    setCurrentPage(1); // Arama veya filtreleme yapıldığında ilk sayfaya dön
  }, [searchTerm, selectedClass, students]);
  // Pagination hesaplamaları
  const indexOfLastStudent = currentPage * studentsPerPage;
  const indexOfFirstStudent = indexOfLastStudent - studentsPerPage;
  const currentStudents = filteredStudents.slice(indexOfFirstStudent, indexOfLastStudent);
  const totalPages = Math.ceil(filteredStudents.length / studentsPerPage);
  // Form değişikliklerini işleme
  const handleInputChange = useCallback((e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prevData => ({
      ...prevData,
      [name]: value
    }));
    // Validasyon
    if (name === 'firstName') {
      if (!value.trim()) {
        setFormErrors(prev => ({
          ...prev,
          firstName: 'Bu alan zorunludur'
        }));
      } else {
        setFormErrors(prev => ({
          ...prev,
          firstName: ''
        }));
      }
    }
  }, []);
  // Öğrenci ekleme/düzenleme modalı
  const renderStudentFormModal = () => <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm" data-id="element-882">
      <AuroraFloatingCard className="w-full max-w-2xl" data-id="element-883">
        <div className="p-6" data-id="element-884">
          <div className="flex justify-between items-center mb-6" data-id="element-885">
            <h3 className="text-xl font-bold text-white" data-id="element-886">
              {isEditMode ? 'Öğrenci Düzenle' : 'Yeni Öğrenci Ekle'}
            </h3>
            <button onClick={closeAddModal} className="text-gray-400 hover:text-white transition-colors" type="button" data-id="element-887">
              <X size={24} data-id="element-888" />
            </button>
          </div>
          <div className="space-y-4" data-id="element-889">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-890">
              {/* Ad */}
              <div data-id="element-891">
                <label htmlFor="firstName" className="block text-sm font-medium text-gray-300 mb-1" data-id="element-892">
                  Adı <span className="text-red-500" data-id="element-893">*</span>
                </label>
                <input type="text" id="firstName" name="firstName" value={formData.firstName} onChange={handleInputChange} className={`w-full bg-gray-800/50 border ${formErrors.firstName ? 'border-red-500' : 'border-purple-500/30'} rounded-lg px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-purple-500`} data-id="element-894" />
                {formErrors.firstName && <p className="mt-1 text-sm text-red-500" data-id="element-895">
                    {formErrors.firstName}
                  </p>}
              </div>
              {/* Soyad */}
              <div data-id="element-896">
                <label htmlFor="lastName" className="block text-sm font-medium text-gray-300 mb-1" data-id="element-897">
                  Soyadı
                </label>
                <input type="text" id="lastName" name="lastName" value={formData.lastName} onChange={handleInputChange} className="w-full bg-gray-800/50 border border-purple-500/30 rounded-lg px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-purple-500" data-id="element-898" />
              </div>
              {/* E-posta */}
              <div data-id="element-899">
                <label htmlFor="email" className="block text-sm font-medium text-gray-300 mb-1" data-id="element-900">
                  E-posta Adresi
                </label>
                <input type="email" id="email" name="email" value={formData.email} onChange={handleInputChange} className="w-full bg-gray-800/50 border border-purple-500/30 rounded-lg px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-purple-500" data-id="element-901" />
              </div>
              {/* Telefon */}
              <div data-id="element-902">
                <label htmlFor="phone" className="block text-sm font-medium text-gray-300 mb-1" data-id="element-903">
                  Telefon Numarası
                </label>
                <input type="text" id="phone" name="phone" value={formData.phone} onChange={handleInputChange} className="w-full bg-gray-800/50 border border-purple-500/30 rounded-lg px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-purple-500" data-id="element-904" />
              </div>
              {/* Veli Adı */}
              <div data-id="element-905">
                <label htmlFor="parentName" className="block text-sm font-medium text-gray-300 mb-1" data-id="element-906">
                  Veli Adı Soyadı
                </label>
                <input type="text" id="parentName" name="parentName" value={formData.parentName} onChange={handleInputChange} className="w-full bg-gray-800/50 border border-purple-500/30 rounded-lg px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-purple-500" data-id="element-907" />
              </div>
              {/* Veli Telefonu */}
              <div data-id="element-908">
                <label htmlFor="parentPhone" className="block text-sm font-medium text-gray-300 mb-1" data-id="element-909">
                  Veli Telefon Numarası
                </label>
                <input type="text" id="parentPhone" name="parentPhone" value={formData.parentPhone} onChange={handleInputChange} className="w-full bg-gray-800/50 border border-purple-500/30 rounded-lg px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-purple-500" data-id="element-910" />
              </div>
              {/* Sınıf */}
              <div data-id="element-911">
                <label htmlFor="class" className="block text-sm font-medium text-gray-300 mb-1" data-id="element-912">
                  Sınıf
                </label>
                <div className="relative" data-id="element-913">
                  <select id="class" name="class" value={formData.class} onChange={handleInputChange} className="w-full bg-gray-800/50 border border-purple-500/30 rounded-lg px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-purple-500 appearance-none pr-10" style={{
                  background: `linear-gradient(rgba(30, 30, 40, 0.4), rgba(20, 20, 30, 0.4))`,
                  boxShadow: 'inset 0 1px 1px rgba(255, 255, 255, 0.05)'
                }} data-id="element-914">
                    {classOptions.map(option => <option key={option} value={option} className="bg-gray-800 text-white" data-id="element-915">
                        {option}
                      </option>)}
                  </select>
                  <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none" data-id="element-916">
                    <svg className="w-5 h-5 text-purple-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-917">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" data-id="element-918" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex justify-end gap-3 mt-6" data-id="element-919">
              <button type="button" onClick={closeAddModal} className="px-4 py-2 bg-gray-700 hover:bg-gray-600 text-white rounded-lg transition-colors" data-id="element-920">
                İptal
              </button>
              <button type="button" onClick={handleSaveStudent} className="px-4 py-2 bg-gradient-to-r from-blue-600 to-purple-600 hover:opacity-90 text-white rounded-lg transition-colors" data-id="element-921">
                {isEditMode ? 'Güncelle' : 'Kaydet'}
              </button>
            </div>
          </div>
        </div>
      </AuroraFloatingCard>
    </div>;
  // Öğrenci silme onay modalı
  const renderDeleteConfirmationModal = () => <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm" data-id="element-922">
      <AuroraFloatingCard className="w-full max-w-md" data-id="element-923">
        <div className="p-6" data-id="element-924">
          <h3 className="text-xl font-bold text-white mb-4" data-id="element-925">Öğrenciyi Sil</h3>
          <p className="text-gray-300 mb-6" data-id="element-926">
            <span className="font-semibold text-purple-400" data-id="element-927">
              {currentStudent?.firstName} {currentStudent?.lastName}
            </span>{' '}
            isimli öğrenciyi silmek istediğinize emin misiniz? Bu işlem geri
            alınamaz.
          </p>
          <div className="flex justify-end gap-3" data-id="element-928">
            <button onClick={() => setShowDeleteModal(false)} className="px-4 py-2 bg-gray-700 hover:bg-gray-600 text-white rounded-lg transition-colors" data-id="element-929">
              İptal
            </button>
            <button onClick={handleDeleteStudent} className="px-4 py-2 bg-gradient-to-r from-red-500 to-pink-600 hover:opacity-90 text-white rounded-lg transition-colors" data-id="element-930">
              Evet, Sil
            </button>
          </div>
        </div>
      </AuroraFloatingCard>
    </div>;
  // Öğrenci ekleme veya güncelleme
  const handleSaveStudent = () => {
    // Ad alanı boş kontrolü
    if (!formData.firstName.trim()) {
      setFormErrors({
        ...formErrors,
        firstName: 'Bu alan zorunludur'
      });
      return;
    }
    if (isEditMode && currentStudent) {
      // Öğrenciyi güncelle
      const updatedStudents = students.map(student => student.id === currentStudent.id ? {
        ...student,
        firstName: formData.firstName,
        lastName: formData.lastName,
        email: formData.email,
        phone: formData.phone,
        parentName: formData.parentName,
        parentPhone: formData.parentPhone,
        class: formData.class
      } : student);
      setStudents(updatedStudents);
    } else {
      // Yeni öğrenci ekle
      const newStudent: Student = {
        id: Math.max(...students.map(s => s.id), 0) + 1,
        firstName: formData.firstName,
        lastName: formData.lastName,
        email: formData.email,
        phone: formData.phone,
        parentName: formData.parentName,
        parentPhone: formData.parentPhone,
        class: formData.class,
        registrationDate: new Date().toLocaleDateString('tr-TR')
      };
      setStudents([...students, newStudent]);
    }
    // Modalı kapat ve formu sıfırla
    closeAddModal();
  };
  // Öğrenci silme
  const handleDeleteStudent = () => {
    if (currentStudent) {
      const updatedStudents = students.filter(student => student.id !== currentStudent.id);
      setStudents(updatedStudents);
      setShowDeleteModal(false);
      setCurrentStudent(null);
    }
  };
  // Düzenleme modalını aç
  const openEditModal = (student: Student) => {
    setCurrentStudent(student);
    setFormData({
      firstName: student.firstName,
      lastName: student.lastName,
      email: student.email,
      phone: student.phone,
      parentName: student.parentName,
      parentPhone: student.parentPhone,
      class: student.class
    });
    setIsEditMode(true);
    setShowAddModal(true);
  };
  // Silme modalını aç
  const openDeleteModal = (student: Student) => {
    setCurrentStudent(student);
    setShowDeleteModal(true);
  };
  // Ekleme/düzenleme modalını kapat
  const closeAddModal = () => {
    setShowAddModal(false);
    setIsEditMode(false);
    setCurrentStudent(null);
    setFormData({
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      parentName: '',
      parentPhone: '',
      class: classOptions[0]
    });
    setFormErrors({
      firstName: ''
    });
  };
  // Pagination işlevleri
  const goToPage = (page: number) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };
  return <div className="space-y-6 p-4" data-id="element-931">
      {/* Başlık */}
      <div className="flex items-center gap-3" data-id="element-932">
        <h1 className="text-3xl font-bold" data-id="element-933">Öğrenci Yönetimi</h1>
        <Users className="w-8 h-8 text-green-400" data-id="element-934" />
      </div>
      {/* Ana Kart */}
      <AuroraFloatingCard data-id="element-935">
        {/* Üst Kontroller */}
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-6 gap-4" data-id="element-936">
          <div className="flex flex-col sm:flex-row gap-3 w-full md:w-auto" data-id="element-937">
            {/* Arama */}
            <div className="relative" data-id="element-938">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} data-id="element-939" />
              <input type="text" placeholder="Öğrenci adı ile ara..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} className="pl-10 pr-4 py-2 w-full sm:w-64 bg-gray-800/50 border border-purple-500/30 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent" data-id="element-940" />
            </div>
            {/* Sınıf Filtresi - Aurora Tasarım Stiliyle */}
            <div className="relative group" data-id="element-941">
              <Filter className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} data-id="element-942" />
              <select value={selectedClass} onChange={e => setSelectedClass(e.target.value)} className="pl-10 pr-10 py-2 w-full sm:w-48 bg-gray-800/50 border border-purple-500/30 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent appearance-none bg-[url('data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22none%22%20viewBox%3D%220%200%2020%2020%22%3E%3Cpath%20stroke%3D%22%23a78bfa%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%222%22%20d%3D%22m6%208%204%204%204-4%22%2F%3E%3C%2Fsvg%3E')] bg-[position:right_0.5rem_center] bg-[size:1.5em_1.5em] bg-no-repeat" style={{
              backgroundImage: `linear-gradient(rgba(30, 30, 40, 0.4), rgba(20, 20, 30, 0.4))`,
              boxShadow: 'inset 0 1px 1px rgba(255, 255, 255, 0.05)'
            }} data-id="element-943">
                <option value="" className="bg-gray-800 text-white" data-id="element-944">
                  Tüm Sınıflar
                </option>
                {classOptions.map(option => <option key={option} value={option} className="bg-gray-800 text-white" data-id="element-945">
                    {option}
                  </option>)}
              </select>
              <style jsx data-id="element-946">{`
                select option:hover {
                  background-color: rgba(139, 92, 246, 0.3) !important;
                }
                select option:checked {
                  background: linear-gradient(
                    to right,
                    #4f46e5,
                    #7c3aed
                  ) !important;
                }
              `}</style>
            </div>
          </div>
          {/* Yeni Öğrenci Ekle Butonu */}
          <button onClick={() => {
          setIsEditMode(false);
          setShowAddModal(true);
        }} className="px-4 py-2 bg-gradient-to-r from-green-500 to-teal-500 hover:opacity-90 text-white rounded-lg transition-colors flex items-center gap-2 whitespace-nowrap" data-id="element-947">
            <Plus size={18} data-id="element-948" />
            Yeni Öğrenci Ekle
          </button>
        </div>
        {/* Öğrenci Tablosu veya Boş Durum */}
        {students.length === 0 ? <div className="text-center py-12" data-id="element-949">
            <Users className="w-16 h-16 text-gray-600 mx-auto mb-4" data-id="element-950" />
            <p className="text-gray-400 mb-4" data-id="element-951">
              Henüz hiç öğrenciniz yok. İlk öğrencinizi eklemek için '+ Yeni
              Öğrenci Ekle' butonuna tıklayarak başlayın.
            </p>
          </div> : <>
            {/* Öğrenci Tablosu */}
            <div className="overflow-x-auto" data-id="element-952">
              <table className="w-full" data-id="element-953">
                <thead data-id="element-954">
                  <tr className="border-b border-gray-700" data-id="element-955">
                    <th className="px-4 py-3 text-left text-sm font-medium text-gray-300" data-id="element-956">
                      Adı Soyadı
                    </th>
                    <th className="px-4 py-3 text-left text-sm font-medium text-gray-300" data-id="element-957">
                      Sınıfı
                    </th>
                    <th className="px-4 py-3 text-left text-sm font-medium text-gray-300" data-id="element-958">
                      Kayıt Tarihi
                    </th>
                    <th className="px-4 py-3 text-left text-sm font-medium text-gray-300" data-id="element-959">
                      Öğrenci Telefon No
                    </th>
                    <th className="px-4 py-3 text-left text-sm font-medium text-gray-300" data-id="element-960">
                      Veli Telefon No
                    </th>
                    <th className="px-4 py-3 text-right text-sm font-medium text-gray-300" data-id="element-961">
                      Eylemler
                    </th>
                  </tr>
                </thead>
                <tbody data-id="element-962">
                  {currentStudents.map(student => <tr key={student.id} className="border-b border-gray-800 hover:bg-gray-800/30" data-id="element-963">
                      <td className="px-4 py-3 text-white" data-id="element-964">
                        {student.firstName} {student.lastName}
                      </td>
                      <td className="px-4 py-3 text-gray-300" data-id="element-965">
                        {student.class}
                      </td>
                      <td className="px-4 py-3 text-gray-300" data-id="element-966">
                        {student.registrationDate}
                      </td>
                      <td className="px-4 py-3 text-gray-300" data-id="element-967">
                        {student.phone}
                      </td>
                      <td className="px-4 py-3 text-gray-300" data-id="element-968">
                        {student.parentPhone}
                      </td>
                      <td className="px-4 py-3 text-right" data-id="element-969">
                        <div className="flex justify-end gap-2" data-id="element-970">
                          <button onClick={() => openEditModal(student)} className="p-1.5 bg-blue-500/10 hover:bg-blue-500/20 text-blue-400 rounded-lg transition-colors" title="Düzenle" data-id="element-971">
                            <Edit2 size={16} data-id="element-972" />
                          </button>
                          <button onClick={() => openDeleteModal(student)} className="p-1.5 bg-red-500/10 hover:bg-red-500/20 text-red-400 rounded-lg transition-colors" title="Sil" data-id="element-973">
                            <Trash2 size={16} data-id="element-974" />
                          </button>
                        </div>
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>
            {/* Pagination */}
            {totalPages > 1 && <div className="flex justify-center items-center gap-2 mt-6" data-id="element-975">
                <button onClick={() => goToPage(currentPage - 1)} disabled={currentPage === 1} className="p-1.5 rounded-lg bg-gray-700/50 text-gray-300 hover:bg-gray-700 disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-976">
                  <ChevronLeft size={18} data-id="element-977" />
                </button>
                {Array.from({
            length: totalPages
          }, (_, i) => i + 1).map(page => <button key={page} onClick={() => goToPage(page)} className={`w-8 h-8 rounded-lg ${currentPage === page ? 'bg-gradient-to-r from-blue-600 to-purple-600 text-white' : 'bg-gray-700/50 text-gray-300 hover:bg-gray-700'}`} data-id="element-978">
                    {page}
                  </button>)}
                <button onClick={() => goToPage(currentPage + 1)} disabled={currentPage === totalPages} className="p-1.5 rounded-lg bg-gray-700/50 text-gray-300 hover:bg-gray-700 disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-979">
                  <ChevronRight size={18} data-id="element-980" />
                </button>
              </div>}
          </>}
      </AuroraFloatingCard>
      {/* Modals */}
      {showAddModal && renderStudentFormModal()}
      {showDeleteModal && renderDeleteConfirmationModal()}
    </div>;
}